import { useEffect, useState } from "react";
// import clsx from "clsx";

import {
  tinyMceVariableInsert,
  isStringifiedJsonObject,
} from "../../helpers/text";
import styles from "../../styles/tinymce.module.css";

// import { Editor } from "@tinymce/tinymce-react";

function MinutesRender({ meeting }) {
  const [value, setValue] = useState();
  // const [iframeHeight, setIframeHeight] = useState(0);

  // useEffect(() => {
  //   const iframe = document.getElementById("myIframe");

  //   const checkHeight = () => {
  //     const height = iframe?.contentWindow.document.body.scrollHeight;
  //     if (height !== iframeHeight) {
  //       setIframeHeight(height);
  //     } else {
  //       clearInterval(interval);
  //     }
  //   };

  //   const interval = setInterval(checkHeight, 500); // Check every 500 milliseconds

  //   return () => clearInterval(interval);
  // }, [value, iframeHeight]);

  useEffect(() => {
    try {
      if (meeting) {
        if (meeting?.board.minutesHeadingTitle.length > 0) {
          if (isStringifiedJsonObject(meeting?.board.minutesHeadingTitle)) {
            const variablesInserted = tinyMceVariableInsert(
              JSON.parse(meeting.board.minutesHeadingTitle),
              {
                boardName: meeting.board.name,
                address: `${meeting.room.address.street}, ${meeting.room.address.city}, ${meeting.room.address.state} ${meeting.room.address.zipCode}`,
                startTime: meeting.startTime,
                endTime: meeting.endTime,
                attendance: meeting.attended,
                dateTime: meeting.scheduleDate,
                date: meeting.scheduleDate.replace(/(,\s\d{4}).*/, "$1"),
              }
            );
            setValue(`${variablesInserted}`);
          } else {
            let templateString = `<p style="text-align: center;"><span style="color: rgb(186, 55, 42);">** <strong>The following document is a draft of the minutes and the not the official approved minutes</strong> **</span></p>
            <p style="text-align: center; line-height: 1;"><strong><span style="color: rgb(0, 0, 0);">Minutes for the {{boardName}}</span></strong></p>
            <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{address}}</span></p>
            <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{startTime}} - {{endTime}}</span></p>
            <p style="line-height: 1; text-align: left;">&nbsp;</p>
            <p style="line-height: 1; text-align: left;"><span style="color: rgb(0, 0, 0);"><strong>Roll Call:</strong> <em>(The following members were in attendance)</em></span></p>
            <ul>
             {{attendance}}
            </ul>
              `;
            const templateInserted = tinyMceVariableInsert(templateString, {
              boardName: meeting.board.name,
              address: `${meeting.room.address.street}, ${meeting.room.address.city}, ${meeting.room.address.state} ${meeting.room.address.zipCode}`,
              startTime: meeting.startTime,
              endTime: meeting.endTime,
              attendance: meeting.attended,
              dateTime: meeting.scheduleDate,
              date: meeting.scheduleDate.replace(/(,\s\d{4}).*/, "$1"),
            });
            setValue(`${templateInserted}`);
          }
        } else {
          let templateString = `<p style="text-align: center;"><span style="color: rgb(186, 55, 42);">** <strong>The following document is a draft of the minutes and the not the official approved minutes</strong> **</span></p>
          <p style="text-align: center; line-height: 1;"><strong><span style="color: rgb(0, 0, 0);">Minutes for the {{boardName}}</span></strong></p>
          <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{address}}</span></p>
          <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{startTime}} - {{endTime}}</span></p>
          <p style="line-height: 1; text-align: left;">&nbsp;</p>
          <p style="line-height: 1; text-align: left;"><span style="color: rgb(0, 0, 0);"><strong>Roll Call:</strong> <em>(The following members were in attendance)</em></span></p>
          <ul>
           {{attendance}}
          </ul>
            `;
          const templateInserted = tinyMceVariableInsert(templateString, {
            boardName: meeting.board.name,
            address: `${meeting.room.address.street}, ${meeting.room.address.city}, ${meeting.room.address.state} ${meeting.room.address.zipCode}`,
            startTime: meeting.startTime,
            endTime: meeting.endTime,
            attendance: meeting.attended,
            dateTime: meeting.scheduleDate,
            date: meeting.scheduleDate.replace(/(,\s\d{4}).*/, "$1"),
          });
          setValue(`${templateInserted}`);
        }
      }
    } catch (error) {
      console.error(error);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting]);

  // useEffect(() => {
  //   try {
  //     if (meeting) {
  //       if (meeting?.board.minutesHeadingTitle.length > 0) {
  //         if (isStringifiedJsonObject(meeting?.board.minutesHeadingTitle)) {
  //           const variablesInserted = tinyMceVariableInsert(
  //             JSON.parse(meeting.board.minutesHeadingTitle),
  //             {
  //               boardName: meeting.board.name,
  //               address: `${meeting.room.address.street}, ${meeting.room.address.city}, ${meeting.room.address.state} ${meeting.room.address.zipCode}`,
  //               startTime: meeting.startTime,
  //               endTime: meeting.endTime,
  //               attendance: meeting.attended,
  //             }
  //           );
  //           setValue(`<!DOCTYPE html>
  //           <html lang="en">
  //           <head>
  //             <meta charset="UTF-8">
  //             <meta name="viewport" content="width=device-width, initial-scale=1.0">
  //             <title>Document</title>
  //             <link rel="stylesheet" href="/styles/tinymce.css"> <!-- Your TinyMCE CSS Link -->
  //             <!-- Include any other styles specific to your content -->
  //           </head>
  //           <body>
  //             ${variablesInserted}
  //           </body>
  //           </html>`);
  //         } else {
  //           let templateString = `<p style="text-align: center;"><span style="color: rgb(186, 55, 42);">** <strong>The following document is a draft of the minutes and the not the official approved minutes</strong> **</span></p>
  //           <p style="text-align: center; line-height: 1;"><strong><span style="color: rgb(0, 0, 0);">Minutes for the {{boardName}}</span></strong></p>
  //           <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{address}}</span></p>
  //           <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{startTime}} - {{endTime}}</span></p>
  //           <p style="line-height: 1; text-align: left;">&nbsp;</p>
  //           <p style="line-height: 1; text-align: left;"><span style="color: rgb(0, 0, 0);"><strong>Roll Call:</strong> <em>(The following members were in attendance)</em></span></p>
  //           <ul>
  //            {{attendance}}
  //           </ul>
  //             `;
  //           const templateInserted = tinyMceVariableInsert(templateString, {
  //             boardName: meeting.board.name,
  //             address: `${meeting.room.address.street}, ${meeting.room.address.city}, ${meeting.room.address.state} ${meeting.room.address.zipCode}`,
  //             startTime: meeting.startTime,
  //             endTime: meeting.endTime,
  //             attendance: meeting.attended,
  //           });
  //           setValue(`<!DOCTYPE html>
  //           <html lang="en">
  //           <head>
  //             <meta charset="UTF-8">
  //             <meta name="viewport" content="width=device-width, initial-scale=1.0">
  //             <title>Document</title>
  //             <link rel="stylesheet" href="/styles/tinymce.css"> <!-- Your TinyMCE CSS Link -->
  //             <!-- Include any other styles specific to your content -->
  //           </head>
  //           <body>
  //             ${templateInserted}
  //           </body>
  //           </html>`);
  //         }
  //       } else {
  //         let templateString = `<p style="text-align: center;"><span style="color: rgb(186, 55, 42);">** <strong>The following document is a draft of the minutes and the not the official approved minutes</strong> **</span></p>
  //         <p style="text-align: center; line-height: 1;"><strong><span style="color: rgb(0, 0, 0);">Minutes for the {{boardName}}</span></strong></p>
  //         <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{address}}</span></p>
  //         <p style="text-align: center; line-height: 1;"><span style="color: rgb(0, 0, 0);">{{startTime}} - {{endTime}}</span></p>
  //         <p style="line-height: 1; text-align: left;">&nbsp;</p>
  //         <p style="line-height: 1; text-align: left;"><span style="color: rgb(0, 0, 0);"><strong>Roll Call:</strong> <em>(The following members were in attendance)</em></span></p>
  //         <ul>
  //          {{attendance}}
  //         </ul>
  //           `;
  //         const templateInserted = tinyMceVariableInsert(templateString, {
  //           boardName: meeting.board.name,
  //           address: `${meeting.room.address.street}, ${meeting.room.address.city}, ${meeting.room.address.state} ${meeting.room.address.zipCode}`,
  //           startTime: meeting.startTime,
  //           endTime: meeting.endTime,
  //           attendance: meeting.attended,
  //         });
  //         setValue(`<!DOCTYPE html>
  //         <html lang="en">
  //         <head>
  //           <meta charset="UTF-8">
  //           <meta name="viewport" content="width=device-width, initial-scale=1.0">
  //           <title>Document</title>
  //           <link rel="stylesheet" href="/styles/tinymce.css"> <!-- Your TinyMCE CSS Link -->
  //           <!-- Include any other styles specific to your content -->
  //         </head>
  //         <body>
  //           ${templateInserted}
  //         </body>
  //         </html>`);
  //       }
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [meeting]);

  // return (
  //   <div
  //     className={clsx("w-full")}
  //     style={{ height: `${iframeHeight + 34}px` }}
  //   >
  //     {value && (
  //       <iframe
  //         id="myIframe"
  //         srcDoc={value}
  //         style={{ width: "100%", height: "100%", border: "none" }}
  //         sandbox="allow-same-origin"
  //       ></iframe>
  //     )}
  //   </div>
  // );

  // return (
  //   // <div className="bg-white">
  //   <div className="w-full">
  //     {value && (
  //       <Editor
  //         apiKey={process.env.NEXT_PUBLIC_TINYMCE}
  //         id="minutesRender"
  //         init={{
  //           branding: false,
  //           // menubar: "",
  //           menubar: false,
  //           toolbar: false,
  //           statusbar: false,
  //           plugins:
  //             "paste searchreplace autolink link table hr toc autoresize insertdatetime advlist lists textpattern",
  //           readonly: 1,
  //         }}
  //         value={value}
  //         disabled={true}
  //       />
  //     )}
  //   </div>
  //   // </div>
  // );

  return (
    <div style={{ all: "unset" }}>
      {value && (
        <div
          dangerouslySetInnerHTML={{
            __html: value,
          }}
          style={{
            marginTop: "0.5rem",
            paddingLeft: "2em",
            paddingRight: "2rem",
          }}
          className={`${styles.tinyContainer} print-ready`}
        />
      )}
    </div>
  );
}

export default MinutesRender;
